type CasesSectionHeadProps = {
  id: string;
  eyebrow: string;
  title: string;
  text?: string;
};

// Cabeçalho das seções da página: rótulo rosa, título forte e uma linha de apoio (mesmo padrão das páginas de solução).
export default function CasesSectionHead({ id, eyebrow, title, text }: CasesSectionHeadProps) {
  return (
    <div className="cz-cases-shead">
      <span className="cz-eyebrow cz-cases-shead__eyebrow">{eyebrow}</span>
      <h2 className="cz-cases-title" id={id}>
        {title}
      </h2>
      {text && <p className="cz-cases-subtitle">{text}</p>}
    </div>
  );
}
